<template>
  <div>
    <div class="header">
      <div class="custom-title" :title="title">{{title}}</div>
      <div class="content-hide no-select" @click="autoHide = !autoHide">{{autoHide ? 'Expand all' : 'Auto hide'}}</div>
      <div class="toc-back-button" @click="toggleTOC()" title="Toggle TOC"><i class="fal fa-arrow-right"></i></div>
    </div>

    <div class="toc-search">
      <Search v-on:searcher="onSearch"></Search>
    </div>
      
    <div class="content no-select">
      <slot v-if="searchBookmarks.length > 0">
        <h3>Table of Contents</h3>
      </slot>
      <slot v-else>
        <span>No results found. Please try a different search term.</span>
      </slot>
      <ol v-if="search.length > 0">
        <li v-for="(node, i) in searchBookmarks" :key="i">
          <div @click="goToPage(node)" class="toc-item">{{node.title}}</div>
        </li>
      </ol>
      <ol v-else>
        <li v-for="(node, i) in bookmarks" :key="i">
          <TocItem
            :children="node.children"
            :title="node.title"
            v-bind="{node, autoHide, currentPage, onCurrentPageChanged}"
          >
          </TocItem>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
  const _ = require('lodash');
  
  import Vue from 'vue'
  import utils from '@/utils/utils.js'; 
  import TocItem from './TocItem';
  import Search from '@/components/widgets/Search'; 
  
  export default {
    name: 'Toc',
    components: {
      TocItem,
      Search
    },
    props: {
      bookmarks: {
        type: Array,
        required: true
      },
      title: {
        type: String,
        required: true
      },
      currentPage: {
        type: Object,
        required: true
      },
      onCurrentPageChanged: Function,
      toggleTOC: Function
    },
    data: function () {
      var t = this;

      return {
        autoHide: true,
        search: '',
        bookmarksFlattened: []
      }
    },
    mounted() {
      var t = this;
      _.each(this.bookmarks, function(item) {
        t.populateBookmarksFlattened(item);
      })
    },
    computed: {
      searchBookmarks() {
        return this.bookmarksFlattened.filter(bookmark => {
          return bookmark.title.toLowerCase().includes(this.search.toLowerCase())
        })
      }
    },
    methods: {
      onSearch: function(val) {
        this.search = val;
      },
      populateBookmarksFlattened: function(item) {
        var t = this;
        this.bookmarksFlattened.push(item);
        if (item.children){
          _.each(item.children, function(item) {
            t.populateBookmarksFlattened(item);
          })
        }
      },
      goToPage: function (node) {
        var page;
        if (node && node.pageRange) {
          // epub
          page = node.pageRange[0];
        } else if (node && node.page){
          // pdf
          page = node.page;
        }        
        if (page <= 0) {
          page = 1;
        }
        this.onCurrentPageChanged(page, 'toc');
      }
    }
  }

</script>

<style scoped lang="scss">
@import "src/css/vars.scss";

.toc-item {
  cursor: pointer;
  color: $primary-color;
  text-decoration: underline;
  padding: 5px 0;
}

ol, li {
  margin: -10px;
  padding: -10px;
}

.content {
  height: calc(100vh - 194px);
  overflow: auto;
  overflow-x: hidden;
  padding: 0 20px 30px 20px;
  text-align: left;
}

.toc-search {
  margin: 20px 10px 0 10px;
}

.header {
  position: relative;
  display: flex;
  padding: 3px 5px 15px 5px;
  width: 100%;
  border-bottom: 1px solid $background-color-darker3;
  height: 42px;
  
  .custom-title {
    flex: 1;
    width: 170px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding-left: 10px;
  }

  .content-hide {
    display: flex;
    width: 94px;
    vertical-align: middle;
    white-space: nowrap;
    color: $primary-color;
    cursor: pointer;
    padding: 0 10px;
    margin-right: 30px;
  }
}


</style>


